import { GoogleGenAI } from "@google/genai";

const API_KEY = process.env.REACT_APP_GEMINI_API;

const ai = new GoogleGenAI({ apiKey: API_KEY });

const AI = {
  geminiText: async (prompt, msgs = []) => {
    try {
      const chat = ai.chats.create({
        name: "Lonas",
        model: "gemini-2.5-flash",
        history: [...msgs],
      });

      const response = await chat.sendMessage({ message: prompt });
      return { type: "data", role: "model", content: response.text };
    } catch (error) {
      console.error("Gemini Error:", error);
      return {
        type: "data",
        role: "model",
        content: "⚠️ Something went wrong.",
      };
    }
  },

  genImage: async (prompt) => {
    try {
      let aspect = "1:1";
      let speed = Date.now();
      const imgURL = `https://api.a0.dev/assets/image?text=${encodeURIComponent(
        prompt
      )}&aspect=${aspect}&seed=${speed}`;

      const res = await fetch(imgURL, {
        method: "GET",
        redirect: "follow",
      });

      if (!res.ok) throw new Error("Image fetch failed");    

      const finalImage = res.url;

      return { type: "data", role: "model", link: finalImage };
    } catch (error) {
      console.error("Gemini Image Error:", error);
      return {
        type: "data",
        role: "model",
        content: "⚠️ Something went wrong with image processing.",
      };
    }
  },
};

export default AI;
